var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-icon",
    transform: "translate(-506 -349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 48,
    height: 48,
    transform: "translate(506 349)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    "data-name": "Path 4359",
    d: "M39,14V39.986A2,2,0,0,1,37.013,42H4.987A1.985,1.985,0,0,1,3,40.016V3.984A2.009,2.009,0,0,1,5,2H26.994Zm-4,2H25V6H7V38H35ZM13,12h6v4H13Zm0,8H29v4H13Zm0,8H29v4H13Z",
    transform: "translate(509 351)",
    fill: "#09c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.15ef956a29c77546311086f317aafc88.svg";
export { ForwardRef as ReactComponent };